import { Money } from '@libs/money/money.interfaces';
import {
    BasicApplication,
    MediumApplication,
    HighApplication,
} from '@/api/LeaBank/leaBank.interfaces.application';
import {
    Applicant,
    BasicApplicant,
    HighApplicant,
    MediumApplicant,
} from '@/api/LeaBank/leaBank.interfaces.applicant';
import { Purchase } from '@/api/LeaBank/leaBank.interfaces.purchase';

export interface LeaBankEndPoint {
    CreateApplication(data: LoanApplication): Promise<LoanApplicationResponse>;
    GetPricing(data: Money): Promise<PricingResponse>;
}

export type LoanApplication =
    | BasicLoanApplication
    | MediumLoanApplication
    | HighLoanApplication;

export interface BasicLoanApplication {
    application: BasicApplication;
    applicant: BasicApplicant;
    coapplicant?: Applicant;
    purchase: Purchase[];
}

export interface MediumLoanApplication {
    application: MediumApplication;
    applicant: MediumApplicant;
    coapplicant?: Applicant;
    purchase: Purchase[];
}

export interface HighLoanApplication {
    application: HighApplication;
    applicant: HighApplicant;
    coapplicant?: Applicant;
    purchase: Purchase[];
}

export interface LoanApplicationResponse {
    result: LoanApplicationResult;
    payload?: string | null;
}

export enum LoanApplicationResult {
    Created = 'Created',
    Approved = 'Approved',
    DocumentSent = 'DocumentSent',
    DocumentSigned = 'DocumentSigned',
    ReadyForDisbursement = 'ReadyForDisbursement',
    AwaitingConfirmation = 'AwaitingConfirmation',
    Disbursed = 'Disbursed',
    Declined = 'Declined',
    Canceled = 'Canceled',
    UnknownError = 'UnknownError',
}

export interface PaymentOption {
    installments: number | null;
    amount: number | null;
    initialFee: number;
    interestRate: number;
}

export type PricingResponse = PaymentOption[];

export enum LoanType {
    Basic = 'Basic',
    Medium = 'Medium',
    High = 'High',
}

export enum LoanThreshold {
    Low = 25000,
    High = 50000,
}

export enum LoanStatus {
    Initial = 'Initial',
    Approved = 'Approved',
    Declined = 'Declined',
    Error = 'Error',
}
